/* product-info.js */
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        const quantityRulesSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (quantityRulesSpinner) quantityRulesSpinner.classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (quantityRulesSpinner) quantityRulesSpinner.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated || !this.quantityForm) return;
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

/* product-video-reviews.js */
(function () {
  const YOUTUBE_ID = /^[\w-]{6,20}$/;

  const boot = () => {
    document.querySelectorAll('[data-video-reviews]').forEach(init);
  };

  const init = (root) => {
    if (root.dataset.videoReviewsReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const dataNode = root.querySelector('[data-video-reviews-data]');
    if (!dataNode) return;

    let items = [];
    try {
      items = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    items = items.filter((item) => item && (YOUTUBE_ID.test(item.id) || item.image));
    if (!items.length) return;

    root.dataset.videoReviewsReady = 'true';

    const count = items.length;
    const slider = root.querySelector('.video-reviews__slider');
    if (count >= 2 && slider) {
      const prev = root.querySelector('.carousel-nav__arrow--prev');
      const next = root.querySelector('.carousel-nav__arrow--next');
      const options = {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchOverflow: true,
      };
      if (count >= 3 && prev && next) {
        options.navigation = { prevEl: prev, nextEl: next };
      }
      new Swiper(slider, options);
    }

    const modal = root.querySelector('[data-video-reviews-modal]');
    const frame = root.querySelector('[data-video-reviews-frame]');
    const nameEl = root.querySelector('[data-video-reviews-name]');
    const authorEl = root.querySelector('[data-video-reviews-author]');
    const dateEl = root.querySelector('[data-video-reviews-date]');
    const textEl = root.querySelector('[data-video-reviews-text]');
    const moreBtn = root.querySelector('[data-video-reviews-more]');
    const moreLabel = root.querySelector('[data-video-reviews-more-label]');
    const countEl = root.querySelector('[data-video-reviews-count]');
    const pager = root.querySelector('[data-video-reviews-pager]');
    const prevBtn = root.querySelector('[data-video-reviews-prev]');
    const nextBtn = root.querySelector('[data-video-reviews-next]');
    const closeBtn = root.querySelector('.video-reviews-modal__close');
    document.querySelectorAll('body > [data-video-reviews-modal]').forEach((node) => node.remove());
    document.body.appendChild(modal);
    let index = 0;
    let lastFocus = null;

    const show = (nextIndex) => {
      index = (nextIndex + count) % count;
      const item = items[index];
      frame.classList.toggle('is-short', Boolean(item.short) && !item.image);
      frame.classList.toggle('is-photo', Boolean(item.image));
      frame.querySelectorAll('iframe, .video-reviews-modal__photo').forEach((node) => node.remove());
      if (item.image) {
        const img = document.createElement('img');
        img.className = 'video-reviews-modal__photo';
        img.src = item.image;
        img.alt = item.name || '';
        frame.appendChild(img);
      } else if (YOUTUBE_ID.test(item.id)) {
        const src = 'https://www.youtube-nocookie.com/embed/' + item.id + '?autoplay=1&rel=0';
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = item.name || 'YouTube video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
      }

      authorEl.hidden = !item.name;
      if (item.name) {
        nameEl.hidden = false;
        nameEl.textContent = item.name;
      } else {
        nameEl.hidden = true;
        nameEl.textContent = '';
      }

      if (item.date) {
        dateEl.hidden = false;
        dateEl.textContent = item.date;
      } else {
        dateEl.hidden = true;
        dateEl.textContent = '';
      }

      textEl.classList.remove('is-expanded');
      moreBtn.classList.remove('is-expanded');
      moreBtn.hidden = true;
      moreLabel.textContent = 'Read more';
      if (item.text) {
        textEl.hidden = false;
        textEl.textContent = item.text;
        window.requestAnimationFrame(() => {
          moreBtn.hidden = textEl.scrollHeight <= textEl.clientHeight + 1;
        });
      } else {
        textEl.hidden = true;
        textEl.textContent = '';
      }

      pager.hidden = count < 2;
      if (count > 1) {
        countEl.hidden = false;
        countEl.textContent = index + 1 + '/' + count;
        prevBtn.hidden = false;
        nextBtn.hidden = false;
      } else {
        countEl.hidden = true;
        prevBtn.hidden = true;
        nextBtn.hidden = true;
      }
    };

    const open = (nextIndex) => {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('video-reviews-open');
      show(nextIndex);
      closeBtn.focus();
    };

    const close = () => {
      modal.hidden = true;
      frame.querySelectorAll('iframe, .video-reviews-modal__photo').forEach((node) => node.remove());
      document.body.classList.remove('video-reviews-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    root.querySelectorAll('[data-video-reviews-open]').forEach((button) => {
      button.addEventListener('click', () => {
        open(Number(button.getAttribute('data-video-reviews-open')) || 0);
      });
    });

    const seeAll = root.querySelector('[data-video-reviews-see-all]');
    if (seeAll) seeAll.addEventListener('click', () => open(0));

    prevBtn.addEventListener('click', () => show(index - 1));
    nextBtn.addEventListener('click', () => show(index + 1));
    moreBtn.addEventListener('click', () => {
      const expanded = textEl.classList.toggle('is-expanded');
      moreBtn.classList.toggle('is-expanded', expanded);
      moreLabel.textContent = expanded ? 'Read less' : 'Read more';
    });

    modal.querySelectorAll('[data-video-reviews-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft' && count > 1) show(index - 1);
      if (event.key === 'ArrowRight' && count > 1) show(index + 1);
    });
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* custom-product.js */
// product gallery
(function () {
    if (document.querySelector('.product__main_slider')) {
        var swiperThumbs = new Swiper('.product__thumbnails', {
            spaceBetween: 8,
            slidesPerView: 6,
            breakpoints: {
              768: {
                direction: "vertical",
              },
              1024: {
                slidesPerView: 4,
                direction: "vertical",
              }
            }
        });

        var thumbRoot = document.querySelector('.product__thumbnails');
        var loadThumb = function (img) {
          if (!img || !img.dataset.src) return;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        };
        var thumbObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadThumb(entry.target);
            thumbObserver.unobserve(entry.target);
          });
        }, { root: thumbRoot, rootMargin: '20px', threshold: 0.01 });
        thumbRoot.querySelectorAll('img[data-src]').forEach(function (img) {
          thumbObserver.observe(img);
        });
        swiperThumbs.on('slideChange transitionEnd', function () {
          thumbRoot.querySelectorAll('img[data-src]').forEach(function (img) {
            thumbObserver.unobserve(img);
            thumbObserver.observe(img);
          });
        });

        var swiperMain = new Swiper('.product__main_slider', {
          spaceBetween: 18,
          slidesPerView: 1,    
          zoom: true,        
          thumbs: {
            swiper: swiperThumbs,
          },
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: ".product__main_slider .swiper-button-next",
            prevEl: ".product__main_slider .swiper-button-prev",
          },
        }); 

        const galleryParent = document.querySelector('.product__media-wrapper')
        const gallery = document.querySelector('.product__main_slider')
        const closeGallery = document.querySelector('.product__main_slider .closeGallery')
        const overlay = document.querySelector('.overlay')

        gallery.addEventListener('click', (e) => {
          if (e.target.closest('#ZlistWishlist')) return;
          if (!gallery.classList.contains('fullScreen')) {
           gallery.classList.add('fullScreen')
           overlay.classList.add('active')
           document.body.classList.add('overflow-hidden')
           galleryParent.classList.add('active')
          }
      })
      closeGallery.addEventListener('click', (e) => {
        e.stopPropagation()
        gallery.classList.remove('fullScreen')
        overlay.classList.remove('active')
        document.body.classList.remove('overflow-hidden')
        galleryParent.classList.remove('active')
      })
    }
})();

// product customers viewed tabs + slider
(function () {
  const initPanelSwiper = (panel, swipers) => {
    panel.querySelectorAll('.product-customers-viewed__slider').forEach((slider) => {
      if (swipers.has(slider)) return;

      const carousel = slider.closest('.product-customers-viewed__carousel');
      if (!carousel) return;

      const isMobileGrid = slider.dataset.layout === 'mobile-grid';

      swipers.set(
        slider,
        new Swiper(slider, {
          spaceBetween: isMobileGrid ? 14 : 24,
          slidesPerView: isMobileGrid ? 1 : 6,
          navigation: {
            nextEl: carousel.querySelector('.carousel-nav__arrow--next'),
            prevEl: carousel.querySelector('.carousel-nav__arrow--prev'),
          },
        })
      );
    });
  };

  document.querySelectorAll('.product-customers-viewed').forEach((section) => {
    const swipers = new Map();
    const panels = section.querySelectorAll('.product-customers-viewed__panel');
    const tabs = section.querySelectorAll('.product-customers-viewed__tab');

    panels.forEach((panel) => {
      if (panel.classList.contains('active')) {
        initPanelSwiper(panel, swipers);
      }
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        if (!target) return;

        tabs.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === target;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
          if (isActive) {
            initPanelSwiper(panel, swipers);
            panel.querySelectorAll('.product-customers-viewed__slider').forEach((slider) => {
              swipers.get(slider)?.update();
            });
          }
        });
      });
    });
  });
})();
// product customers viewed tabs + slider

// product more collections slider
(function () {
  document.querySelectorAll('.product-more-collections__slider').forEach((slider) => {
    const carousel = slider.closest('.product-more-collections__carousel');
    if (!carousel) return;

    new Swiper(slider, {
      spaceBetween: 24,
      slidesPerView: 'auto',
      navigation: {
        nextEl: carousel.querySelector('.carousel-nav__arrow--next'),
        prevEl: carousel.querySelector('.carousel-nav__arrow--prev'),
      },
    });
  });
})();
// product more collections slider

// product recommedation slider
(function () {
  if (document.querySelector('.related-products__products')) {
    var swiper = new Swiper('.related-products__products', {
        spaceBetween: 24,
        slidesPerView: 'auto',
        navigation: {
            nextEl: ".reviews .swiper-button-next",
            prevEl: ".reviews .swiper-button-prev",
        },
        breakpoints: {
            1024: {
              slidesPerView: 4
            }
          }
    });
  }
})();
// product recommedation slider

// custom select
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    // Get all custom select wrappers
    const selectWrappers = document.querySelectorAll('.customSelectWrapper');

    selectWrappers.forEach(wrapper => {
        const select = wrapper.querySelector('.customSelect');
        const selected = select.querySelector('.selectSelected');
        const options = select.querySelector('.selectItems');

        // Toggle select dropdown
        selected.addEventListener('click', function(event) {
            options.classList.toggle('select-hide');
            select.classList.toggle('select-arrow-active');
            closeAllSelect(wrapper);
            event.stopPropagation();
        });

        // Select an item
        options.querySelectorAll('div').forEach(option => {
            option.addEventListener('click', function(event) {
              if (!selected.classList.contains('no_change_text')) {
                selected.value = this.textContent;
              }
                options.classList.add('select-hide');
                select.classList.remove('select-arrow-active');
                event.stopPropagation();
            });
        });
    });

    // Close dropdown if clicked outside
    document.addEventListener('click', function(event) {
        closeAllSelect();
    });

    function closeAllSelect(exceptWrapper) {
        selectWrappers.forEach(wrapper => {
            if (wrapper !== exceptWrapper) {
                const select = wrapper.querySelector('.customSelect');
                const options = select.querySelector('.selectItems');
                options.classList.add('select-hide');
                select.classList.remove('select-arrow-active');
            }
        });
    }
});
})();
// custom select

// product tabs: anchor navigation (all breakpoints, all blocks visible)
(function () {
  const getScrollOffset = (tabsBar) => (tabsBar ? tabsBar.offsetHeight + 20 : 100);

  const scrollToTarget = (selector, tabsBar) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset(tabsBar);
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const setActiveNav = (tabButtons, activeEl) => {
    tabButtons.forEach((btn) => btn.classList.remove('active'));
    activeEl.classList.add('active');
  };

  const initProductTabs = () => {
    const tabsBar = document.querySelector('.product__info-blocks .product_content__tabs');
    if (!tabsBar) return;

    const tabButtons = Array.from(tabsBar.querySelectorAll('.product_content__tabs_item'));
    if (!tabButtons.length) return;

    tabButtons.forEach((button) => {
      if (button.dataset.tabListenerAttached) return;
      button.dataset.tabListenerAttached = 'true';

      button.addEventListener('click', function (e) {
        const hash = this.getAttribute('href');
        const scrollSelector = this.dataset.scrollTarget || (hash && hash.startsWith('#') ? hash : null);
        if (!scrollSelector) return;

        e.preventDefault();
        setActiveNav(tabButtons, this);
        scrollToTarget(scrollSelector, tabsBar);
        history.replaceState(null, '', scrollSelector);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initProductTabs);
})();

// Judge.me preview badge → product Reviews tab + scroll
(function () {
  document.addEventListener(
    'click',
    function (e) {
      if (e.button !== 0) return;
      const badge = e.target.closest('.jdgm-widget.jdgm-preview-badge');
      if (!badge || !badge.classList.contains('jdgm--done-setup')) return;
      const reviewsTab =
        document.querySelector('.product_content__tabs_item[href="#product-reviews"]') ||
        document.querySelector('.product_content__tabs_item[data-tab="review"]');
      if (!reviewsTab) return;
      e.preventDefault();
      e.stopPropagation();
      reviewsTab.click();
      window.requestAnimationFrame(function () {
        reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    true
  );
})();

// product compatible with accordion
(function () {
  const initCompatibleWith = (root) => {
    root.querySelectorAll('.product-compatible__brand-header').forEach((button) => {
      button.addEventListener('click', () => {
        const brand = button.closest('.product-compatible__brand');
        const isOpen = brand.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('.product-compatible__specific-row').forEach((row) => {
      const text = row.querySelector('.product-compatible__numbers-text');
      const toggle = row.querySelector('.product-compatible__numbers-toggle');
      if (!text || !toggle) return;

      const needsToggle = text.textContent.trim().length > 35 || text.scrollHeight > 22;
      if (needsToggle) {
        row.classList.add('is-expandable');
      }

      toggle.addEventListener('click', () => {
        const isExpanded = row.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    });
  };

  document.querySelectorAll('.product-compatible').forEach(initCompatibleWith);
})();

